import { throttle } from 'throttle-debounce'
export default (fn, interval) => throttle(interval, fn)
